import { createActions, createReducer } from "reduxsauce";
import { patchClient } from "pages/clients/mirrorHints";

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
  fetchClients: [],
  fetchClientsSuccess: ['clients'],
  fetchClientsFailure: ['error'],
  fetchClient: ['id'],
  fetchClientSuccess: ['client'],
  fetchClientFailure: ['error'],
  fetchClientByDoc: ['doc'],
  fetchClientByDocSuccess: ['clients'],
  fetchClientByDocFailure: ['error'],
  postClient: ['client'],
  postClientSuccess: ['data'],
  postClientFailure: ['error'],
  deleteClient: ['id'],
  deleteClientSuccess: ['data'],
  deleteClientFailure: ['error'],
  // patch: campos otimistas (booleans/v2_ingest_key_set); prev: valores a restaurar em erro;
  // key: chave de ingestão (write-only, vai só no PUT, nunca entra no estado)
  updateClient: ['id', 'patch', 'prev', 'key'],
  updateClientSuccess: ['id', 'data'],
  updateClientFailure: ['id', 'prev', 'error'],
  clearClientFeedback: []
})

/**
 * Handlers
 */
const STATE = {
  pending: false,
  clients: [],
  client: null,
  modified: false, //inserted, updated, deleted
  feedback: null, // {type:'success'|'error', message} do PUT de espelhamento
  error: null
}
const INITIAL_STATE = STATE;

// Get All Clients
const getClients = state => {
  return {...state, pending:true, client:null, clients:[], error:null}
}
const getClientsSuccess = (state, { clients }) => {
  return {...state, clients, pending:false, error:null}
};
const getClientsFailure = (state, { error }) => {
  return {...state, pending:false, error }
};

// Get Client by Id
const getClient = state => {
  return {...state, pending:true, error:null}
}
const getClientSuccess = (state, { client }) => {
  return {...state, client, pending:false, error:null}
};
const getClientFailure = (state, { error }) => {
  return {...state, pending:false, error }
};

// Get Client by Document (cpf/cnpj)
const getClientByDoc = state => {
  return {...state, pending:true, error:null}
}
const getClientByDocSuccess = (state, { client }) => {
  return {...state, client, pending:false, error:null}
};
const getClientByDocFailure = (state, { error }) => {
  return {...state, pending:false, error }
};

// Insert Clients
const insertClient = (state, {client}) => {
  return {...state, pending:true, modified:false, error:null}
}
const insertClientSuccess = (state, { data }) => {
  return {...state, pending:false, client:data, modified:true, error:null}
};
const insertClientFailure = (state, { error }) => {
  return {...state, pending: false, error }
};

// Remove Clients
const removeClient = state => {
  return {...state, pending:true, modified:false, error:null}
}
const removeClientSuccess = (state, { data }) => {
  return {...state, pending:false, data, modified:true, error:null}
};
const removeClientFailure = (state, { error }) => {
  return {...state, pending: false, error }
};

// Update Client (espelhamento V1 » V2) - otimista com reversão em erro
const updateClient = (state, { id, patch }) => {
  return {...state, clients: patchClient(state.clients, id, patch), feedback:null, error:null}
}
const updateClientSuccess = (state, { id, data }) => {
  const server = data && typeof data === 'object' ? data : {};
  return {
    ...state,
    clients: patchClient(state.clients, id, server),
    feedback: {type:'success', message:'Configuração salva. O efeito leva até 1 minuto.'},
    error:null
  }
};
const updateClientFailure = (state, { id, prev, error }) => {
  return {
    ...state,
    clients: patchClient(state.clients, id, prev),
    feedback: {type:'error', message:`Não foi possível salvar${error?.message ? `: ${error.message}` : ''}. Alteração revertida.`},
    error
  }
};
const clearClientFeedback = state => ({...state, feedback:null});

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
  [Types.FETCH_CLIENTS]: getClients,
  [Types.FETCH_CLIENTS_SUCCESS]: getClientsSuccess,
  [Types.FETCH_CLIENTS_FAILURE]: getClientsFailure,
  [Types.FETCH_CLIENT]: getClient,
  [Types.FETCH_CLIENT_SUCCESS]: getClientSuccess,
  [Types.FETCH_CLIENT_FAILURE]: getClientFailure,
  [Types.FETCH_CLIENT_BY_DOC]: getClientByDoc,
  [Types.FETCH_CLIENT_BY_DOC_SUCCESS]: getClientByDocSuccess,
  [Types.FETCH_CLIENT_BY_DOC_FAILURE]: getClientByDocFailure,
  [Types.POST_CLIENT]: insertClient,
  [Types.POST_CLIENT_SUCCESS]: insertClientSuccess,
  [Types.POST_CLIENT_FAILURE]: insertClientFailure,
  [Types.DELETE_CLIENT]: removeClient,
  [Types.DELETE_CLIENT_SUCCESS]: removeClientSuccess,
  [Types.DELETE_CLIENT_FAILURE]: removeClientFailure,
  [Types.UPDATE_CLIENT]: updateClient,
  [Types.UPDATE_CLIENT_SUCCESS]: updateClientSuccess,
  [Types.UPDATE_CLIENT_FAILURE]: updateClientFailure,
  [Types.CLEAR_CLIENT_FEEDBACK]: clearClientFeedback,

})